import { useDocTitle } from '@css-xp/base';

export function useTitle(id: string, title?: string, appTitle?: string) {
  useDocTitle(id, title, appTitle);
}
